import React from 'react';
import { Alert, AlertTitle, Button, Container } from '@mui/material';
import { useUser } from '../../contexts/UserContext';

// Shown when a signed-in user's profile could not be loaded. Their status is
// unknown, so they are not sent to registration, application status or a dashboard.
export default function AccountUnavailable() {
  const { refreshProfile } = useUser();
  return <Container maxWidth="sm" sx={{ py: 8 }}>
    <Alert severity="warning" action={<Button color="inherit" size="small" onClick={() => { void refreshProfile(); }}>Try again</Button>}>
      <AlertTitle>We couldn&apos;t load your account</AlertTitle>
      StudySync could not reach the server, so your account details are not available right now.
      Nothing about your account has changed. Check your connection and try again.
    </Alert>
  </Container>;
}
